import { forwardRef, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseSelectProps } from '~/components/inputs/Select/Select';
import SimpleSelect from '~/components/inputs/Select/SimpleSelect';
import { EsigibilitaIva } from '~/types/invoicing';

interface Props extends BaseSelectProps {
  onChange: (value: EsigibilitaIva | null) => void;
  value: EsigibilitaIva | null;
}

const VatCollectionSelect = forwardRef<HTMLDivElement, Props>(({ onChange, ...props }, ref) => {
  const { t } = useTranslation('documents', { keyPrefix: 'builder' });

  const options = useMemo(
    () => [
      { value: '', label: t('fields.vat_collection.options.null') },
      { value: EsigibilitaIva.Immediate, label: t('fields.vat_collection.options.immediate') },
      { value: EsigibilitaIva.Split, label: t('fields.vat_collection.options.split') },
      { value: EsigibilitaIva.Deferred, label: t('fields.vat_collection.options.deferred') },
    ],
    [t],
  );

  const handleChange = useCallback((value: string | null) => onChange(value as EsigibilitaIva | null), [onChange]);
  return <SimpleSelect {...props} emptyValue="" onChange={handleChange} options={options} ref={ref} />;
});

export default VatCollectionSelect;
